var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"size":"fluid","title":_vm.team ? _vm.team.name : ''}},[(_vm.roster)?_c('draft-roster',{attrs:{"roster":_vm.roster}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }